
import {styled, useTheme, Box, useMediaQuery, IconButton, Fade} from 'external/material'
import { mixStyle } from 'utils/style'

import DashboardSidebar from './DashboardSidebar'

import { SideMenuOpenIcon } from 'resources/icons'

import useMenu from 'hooks/menu'

const StyledSidebarContainer = styled(Box)(sidebarContainerStyles)

export default function DashboardSidebarContainer() {

    const {sidebarOpened, toggleSidebar} = useMenu()

    const theme = useTheme()
    const isDesktop = useMediaQuery(theme.breakpoints.up('desktop'))
    const open = isDesktop || sidebarOpened

    return (
      <StyledSidebarContainer>
        {!open && <Fade in={!open} timeout={1000}><IconButton className="open-menu" onClick={() => toggleSidebar(true)}><SideMenuOpenIcon width={27} /></IconButton></Fade>}
        <DashboardSidebar isDesktop={isDesktop} open={open} setOpen={toggleSidebar} />
      </StyledSidebarContainer>
    )
}

function sidebarContainerStyles({theme}) {

  const openMenuTop = mixStyle(theme.mixins.toolbar, ['minHeight', 'maxHeight'], (value, type) => {
    if (type == 'maxHeight') return
    return {top: `${(value * 2) + 5}px`}
  })


  return {
    "& .open-menu": {
      display: 'flex',
      position: 'absolute',
      ...openMenuTop,
      right: 3 
    }
  }
}
